import { render, staticRenderFns } from "./ItemListDetectionLayout.vue?vue&type=template&id=1fc5bc16&scoped=true&"
import script from "./ItemListDetectionLayout.vue?vue&type=script&lang=js&"
export * from "./ItemListDetectionLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc5bc16",
  null
  
)

export default component.exports